---
de:
  fall_lease:
    accumulated: Akkumuliert
    actions: Aktionen
    active: Aktiv
    approve: Genehmigen
    approve_prompt: Sie überschreiben jetzt die vorhandenen Berechnungen. Möchten Sie die Genehmigung wirklich erteilen?
    approved: Bestätigt
    averaging_interval: Durchschnittsintervall
    back: Zurück
    calculation_interval: Berechnungsintervall
    code_list: Code-Liste
    computable: Berechenbar
    computable_computing: Berechnung läuft
    computable_false: Berechnung fehlgeschlagen. Bitte überprüfen Sie, ob alle Parameter korrekt sind, oder kontaktieren Sie Kaia.
    computable_true: Berechnung funktioniert normal
    computable_unknown: Nicht berechnet
    computation_state: Berechnungsstatus
    compute: Berechnen
    compute_all_prompt: |-
      Sie sind dabei, alle Herbstmietverträge zu berechnen.
      Die Aufgabe wird 1-5 Minuten in Anspruch nehmen.
      Sind Sie sicher?
    compute_current_year: Aktuelles Jahr berechnen
    computing_job_status:
      in_queue: In Warteschlange
      not_found: Nicht gefunden, klicken Sie, um es erneut zu versuchen
      running: Läuft
    computing_status: Rechenstatus
    confirm_code_list_clear: Sie werden die Liste der Kontocodes löschen. Bitte bestätigen Sie.
    contract_details: Vertragsdetails
    contract_id: Vertrags-ID
    contract_nr: Vertragsnummer
    contract_structure: Vertragsstruktur
    contract_type: Vertragsart
    counterpart: Gegenpartei
    counterpart_fields:
      add: Gegenpart hinzufügen
      fall_lease: Herbstpacht
      informational_text_accuracy: Ungenauigkeiten und Fehler treten sowohl für aktuelle als auch historische Jahre auf.
      informational_text_test: Dies ist eine Testversion.
      landowner: Grundbesitzer
      landowner_error: Grundbesitzer muss ausgewählt werden
      share: Anteil[%]
      share_error: Gesamtanteil darf 100% nicht überschreiten
      show_landowner_info: Informationen zum Grundbesitzer des Herbstpachtvertrags
    currency: Währung
    disapprove: Ablehnen
    download_xlsx: Herunterladen (xlsx)
    elcert: Elzertifikate
    elcert_codes: Elcert-Code-Liste
    elcert_owners: Elcert-Inhaber
    elcert_share: Rate für Elzertifikate
    end_date: Enddatum
    fall_lease: Zugeständnis
    fall_lease_contract_details: Konzessionsverträge Details
    fall_lease_contracts: Konzessionsverträge
    fall_lease_summary: Konzession Zusammenfassung
    filter_data: Daten filtern
    fixed_price: Landpacht
    goos: GoOs
    goos_codes: GoOs-Code-Liste
    goos_owners: GoOs-Inhaber
    goos_share: Rate für GoOs
    gross: Brutto
    kpi_adjustment: KPI-Anpassung
    kpi_end_date_type: KPI-Enddatum
    kpi_ref_date: KPI-Referenzdatum
    loading_please_wait: Lädt... Bitte warten
    lock: Sperren
    lock_all: Alle Jahre sperren
    lock_prompt: Sie sind dabei, die Parameter zu sperren. Sind Sie sicher, dass Sie sperren möchten?
    lock_prompt_false: Sie entsperren jetzt Parameter. Sind Sie sicher, dass Sie entsperren möchten?
    lock_prompt_true: Sie sperren jetzt Parameter. Sind Sie sicher, dass Sie sperren möchten?
    locked: Gesperrt
    min_price: Mindestfall-Leasingniveau
    model_rate: Modellrate - Stromverkaufseinnahmen
    model_rate_hint: 'Zum Beispiel: 5'
    model_type: Modelltyp
    net: Brutto mit Kosten
    none: Keiner
    payment_dates: Zahlungstermine
    payment_interval: Zahlungsintervall
    power_plant_name: Name der Kraftwerksanlage
    pp_revenues_costs: Umsätze und Kosten des Kraftwerks
    rate_structure: Tarifstruktur
    remove_all: Alle Jahre entfernen
    remove_all_prompt: |-
      Sie sind dabei, ALLE Kraftwerk-Herbstverträge zu ENTFERNEN.
      Sind Sie sicher?
    revenue: Umsätze
    revenue_codes: Einnahmen-Codeliste
    revenue_owners: Umsatzinhaber
    save: Speichern
    save_all_years: Alle Jahre speichern
    save_and_compute: Speichern und berechnen
    save_compute_all: Alle Jahre berechnen
    select_cols_show: Spalten auswählen, die angezeigt werden sollen
    select_columns_to_show: Spalten auswählen, die angezeigt werden sollen
    start_date: Anfangsdatum
    threshold_method: Schwellenwertmethode
    threshold_rate: Schwellenwertrate
    threshold_rate_hint: 'Zum Beispiel: 10, 15, 25'
    threshold_type: Schwellenwerttyp
    threshold_value: Schwellenwert
    threshold_value_hint: 'Zum Beispiel: 0, 16000, 50000'
    total: Gesamt
    total_costs: Gesamtkosten
    total_costs_codes: Gesamtkosten-Code-Liste
    total_costs_owners: Kosteninhaber
    total_fall_leases: Totales Zugeständnis
    unlock: Entsperren
    unlock_all: Alle Jahre entsperren
    websocket_connected: Mit Server verbunden
    websocket_disconnected: Vom Server getrennt
    xledger_api:
      insufficient_credits: Unzureichende XLedger Guthaben, wird zurückgesetzt um %
    xledger_id_not_found: Die XLedger-Projekt-ID ist für dieses Kraftwerk nicht festgelegt.
    yearly_production: Jährliche Produktion
